import { createRouter } from '@tanstack/react-router'
import { rootRoute } from './routes/__root'
import { authLayoutRoute } from './routes/_auth'
import { dashboardRoute } from './routes/_auth.index'
import { createPlaylistRoute } from './routes/_auth.playlists.create'
import { playlistDetailRoute } from './routes/_auth.playlists.$id'
import { signInRoute } from './routes/sign-in'
import { unauthorizedRoute } from './routes/unauthorized'

const routeTree = rootRoute.addChildren([
	authLayoutRoute.addChildren([dashboardRoute, createPlaylistRoute, playlistDetailRoute]),
	signInRoute,
	unauthorizedRoute,
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}
